import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../../Providers/AuthProvider'
import { useConfig } from '../../Providers/ConfigProvider'
import { GetCustomerUsers, GetUserRoles } from '../../Services/UserService'

export const USERS_QUERY_KEY = ['users']

const EMPTY_ARRAY = []

// Użytkownicy kontrahenta - pobierani dopiero przy wejściu w panel "Użytkownicy",
// a nie przy starcie aplikacji dla każdego zalogowanego.
export const useCustomerUsers = () => {
    const { api } = useConfig()
    const { authState } = useAuth()

    const { data, isFetching } = useQuery({
        queryKey: [...USERS_QUERY_KEY, 'customerUsers', authState.custId],
        queryFn: async () => (await GetCustomerUsers(api, authState.custId)).data,
        enabled: Boolean(authState.custId?.trim?.()),
    })

    return { customerUsers: data ?? EMPTY_ARRAY, isLoadingUsers: isFetching }
}

// Słownik ról - potrzebny wyłącznie w oknach nadawania uprawnień.
export const useUserRoles = () => {
    const { api } = useConfig()

    const { data } = useQuery({
        queryKey: [...USERS_QUERY_KEY, 'roles'],
        queryFn: async () => (await GetUserRoles(api)).data,
        staleTime: 60 * 60 * 1000,
    })

    return { userRoles: data ?? EMPTY_ARRAY }
}
